const endpoint = "https://umpb2.cuba-games.com"
const cpoint = "https://cb.cuba-lv.com"

const startpoint = `${cpoint}/`
const mediapoint = `${cpoint}`

const gamePlace = { studio: "bishkek", room: "po2-room" } // tbilisi, bishkek

export { endpoint, mediapoint, startpoint, gamePlace }
